<script>
import { mapGetters } from 'vuex'
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: 'Failure',
    meta: [{ name: 'description', content: 'The payment failure page.' }],
  },
  components: { Layout },
  computed: {
    ...mapGetters({
      brand: 'contentful/getBrand',
    }),
    errorImage() {
      return this.brand?.errorImage?.fields?.file?.url
    },
  },
}
</script>

<template>
  <Layout screen="failure">
    <main :class="$style.page">
      <h3>
        Whoops... We can't process your payment. Please try again or speak to
        your server.
      </h3>
      <img v-if="errorImage" :class="$style.error" :src="errorImage" />
      <BaseLink :to="{ name: 'payment' }">
        <BaseButton :class="$style.button">Try again</BaseButton>
      </BaseLink>
    </main>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.page {
  height: 100%;
  text-align: center;
  max-width: 280px;
  margin: auto;
  padding: 3rem 0;
}

.error {
  width: 70%;
  margin: 2rem auto;
}

.button {
  margin: 1rem 0;
}
</style>
